import React from 'react';
import NeisLearningContentUploadTable from './NeisLearningContentUploadTable';
import type { NeisLearningContentUploadDocumentPayload } from '../../utils/documentExportPreviewStorage';

export type NeisLearningContentUploadExportDocumentProps = {
  payload: NeisLearningContentUploadDocumentPayload;
};

const NeisLearningContentUploadExportDocument = React.forwardRef<
  HTMLDivElement,
  NeisLearningContentUploadExportDocumentProps
>(function NeisLearningContentUploadExportDocument({ payload }, ref) {
  const { termNumber, headerTitle, showDateColumns, viewMode = 'annual-plan', rows } = payload;

  return (
    <div ref={ref} className="cp-document-export-preview-sheet cp-neis-learning-upload-print-root">
      <div className="cp-neis-learning-upload-export-subtitle" data-pdf-element="header">
        <span className={`cp-annual-cross-topic-detail-scope cp-annual-cross-topic-detail-scope--term${termNumber}`}>
          {termNumber}학기
        </span>
        <span className="cp-neis-learning-upload-export-title" title={headerTitle}>
          {headerTitle}
        </span>
      </div>
      <div className="cp-neis-learning-upload-table-wrap">
        <NeisLearningContentUploadTable
          rows={rows}
          showDateColumns={showDateColumns}
          variant={viewMode}
          seqColumnLabel="순서"
        />
      </div>
    </div>
  );
});

export default NeisLearningContentUploadExportDocument;
